// extracted by css-extract-rspack-plugin
export default {"documentsWarning":"_3uovTXBh2P6kRmUKv3R_1Q","hideSubscriptionSelect":"_2my-W7OzDmQSAFG-ALNF_A"};